import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';
import { RvButtonComponent } from '../../../../components/button/button.component';

@Component({
  selector: 'moderator-join-bulk-actions-bar',
  standalone: true,
  imports: [RvButtonComponent, MatButtonModule, MatIconModule, SharedModule],
  templateUrl: './moderator-join-bulk-actions-bar.component.html',
})
export class ModeratorJoinBulkActionsBarComponent {
  @Input({ required: true }) selectedCount!: number;
  @Output() startSharing = new EventEmitter<void>();
  @Output() clearSelection = new EventEmitter<void>();

  get withinSelectionLimit(): boolean {
    return this.selectedCount <= 10;
  }

  get messageText(): string {
    if (!this.withinSelectionLimit) {
      return 'Select up to 10 displays';
    }
    return this.selectedCount === 1 ? 'Display selected' : 'Displays selected';
  }

  get messageClasses(): string {
    return this.withinSelectionLimit
      ? 'tw-text-sm tw-text-white tw-mr-1.5 tw-font-medium tw-whitespace-nowrap'
      : 'tw-text-[12.5px] tw-text-white tw-whitespace-nowrap';
  }

  get clearButtonClass(): string {
    const hover = this.withinSelectionLimit
      ? 'hover:tw-bg-gray-700'
      : 'hover:tw-bg-red-700';
    return `tw-w-2.5 tw-h-2.5 tw-ml-2.5 tw-mr-4 ${hover}`;
  }
}
